import {useMemo} from 'react'
const useModal = (type = 'simple', options = {}) => {

  const {bamboo} = window
  const modal = useMemo(() => {
    if (!!bamboo) {
      const modal = bamboo.createModal(type, options)
      return modal
    }
    return null
  }, [bamboo, type, options])

  return modal
}

export default useModal
